import { SearchModality } from '@aibees/elephant/feature/search-table-company/hooks/types';

export const config = [
  {
    key: 'total',
    label: 'Total Records',
    value: SearchModality.TOTAL,
  },
  {
    key: 'unsaved',
    label: 'Net New Records',
    value: SearchModality.UNSAVED,
  },
  {
    key: 'saved',
    label: 'Saved Records',
    value: SearchModality.SAVED,
  },
];
